<template>
  <div class="coderpix_tm_section" id="contact">
    <div class="section_inner">
      <div class="coderpix_tm_contact">
        <div class="coderpix_tm_main_title">
          <h3>Bana <span class="coloring">Ulaşın</span></h3>
        </div>
        <div class="wrapper">
          <div class="left">
            <ul>
              <!-- Adres -->
              <li v-if="contactData.address">
                <div class="list_inner">
                  <i class="icon-location"></i>
                  <span><a href="#" class="href_location">{{ contactData.address }}</a></span>
                </div>
              </li>
              
              <!-- E-postalar -->
              <li v-for="(email, i) in contactData.emails" :key="`email-${i}`">
                <div class="list_inner">
                  <i class="icon-mail-1"></i>
                  <span><a :href="`mailto:${email}`">{{ email }}</a></span>
                </div>
              </li>

              <!-- Sosyal Medya -->
              <li v-for="(social, i) in contactData.socials" :key="`social-${i}`">
                <div class="list_inner">
                  <i :class="social.icon || 'icon-link'"></i>
                  <span>
                    <a :href="social.url" target="_blank">{{ social.username || social.platform }}</a>
                  </span>
                </div>
              </li>
            </ul>

          </div>
          <div class="right">
            <div class="fields">
              <form
                action="/"
                method="post"
                class="contact_form"
                id="contact_form"
              >
                <div
                  class="returnmessage"
                  data-success="Mesajınız alındı, en kısa sürede sizinle iletişime geçeceğiz."
                ></div>
                <div class="empty_notice">
                  <span>Lütfen gerekli alanları doldurun</span>
                </div>
                <div class="first">
                  <ul>
                    <li>
                      <div class="list_inner">
                        <input
                          id="name"
                          type="text"
                          placeholder="İsim"
                          autocomplete="off"
                        />
                      </div>
                    </li>
                    <li>
                      <div class="list_inner">
                        <input
                          id="email"
                          type="text"
                          placeholder="E-posta"
                          autocomplete="off"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="last">
                  <textarea id="message" placeholder="Mesajınız"></textarea>
                </div>
                <div class="coderpix_tm_button">
                  <a id="send_message" href="#">Gönder</a>
                </div>

                <!-- If you want change mail address to yours, just open "modal" folder >> contact.php and go to line 4 and change detail to yours.  -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sanityClient from "../sanity";

export default {
  name: `ContactComponent`,
  data() {
    return {
      contactData: {
        address: "Ankara, TÜRKİYE",
        emails: ["info@okansahin.net.tr", "coderpix@gmail.com"],
        socials: [
          {
            platform: "Instagram",
            icon: "icon-instagram",
            url: "https://www.instagram.com/okansahinweb",
            username: "@okansahinweb"
          }
        ]
      }
    };
  },
  methods: {
    async fetchContactData() {
      try {
        const query = `*[_type == "contact"][0]`;
        const result = await sanityClient.fetch(query);
        if (result) {
          this.contactData = {
            address: result.address || this.contactData.address,
            emails: result.emails && result.emails.length > 0 ? result.emails : this.contactData.emails,
            socials: result.socials && result.socials.length > 0 ? result.socials : this.contactData.socials
          };
        }
      } catch (error) {
        console.error("Contact fetch error:", error);
      }
    }
  },
  mounted() {
    this.fetchContactData();
  }
};
</script>



